import React, { useEffect, useState } from 'react';
import './styles.css';

const RollingCounter = ({ endValue, duration = 2000 }) => {
  const [currentValue, setCurrentValue] = useState(0);

  useEffect(() => {
    // Number of steps for smooth animation
    const steps = 40;
    const stepDuration = duration / steps;
    const increment = endValue / steps;
    let currentStep = 5;

    const interval = setInterval(() => {
      if (currentStep < steps) {
        setCurrentValue(Math.round(increment * currentStep));
        currentStep++;
      } else {
        setCurrentValue(endValue);
        clearInterval(interval);
      }
    }, stepDuration);

    return () => clearInterval(interval);
  }, [endValue, duration]);

  // Convert current value to array of digits
  const digits = currentValue?.toString().split('');

  return (
    <div className="digit-container">
      {digits?.map((digit, index) => (
        <div className="digit-wrapper" key={index}>
          <div className="digit">{digit}</div>
        </div>
      ))}
    </div>
  );
};

export default RollingCounter;


